import { IconPlus } from "@tabler/icons-react";
import clsx from "clsx";
import Button from "components/Button";
import Modal from "components/Modal";
import JoinOrganisation from "features/Organisation/features/JoinOrganisation";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { globalStore } from "store/GlobalStore";
import { isTabletSize } from "utils";

function JoinCreateOrganisation(props: {
  closeMenu?: () => void;
  buttonStyle?: boolean;
}) {
  const { t } = useTranslation();
  const [openJoin, setOpenJoin] = React.useState(false);

  const closeJoinModal = () => {
    setOpenJoin(false);
    props.closeMenu?.();
  };

  const openJoinModal = () => {
    setOpenJoin(true);
    if (isTabletSize()) {
      globalStore.setSidebarOpened(false);
    }
  };

  return (
    <>
      {props.buttonStyle ? (
        <Button
          leadingIcon={<IconPlus size={24} />}
          width="fit-content"
          onClick={openJoinModal}
        >
          {t("organisationSettings.addOrganisation")}
        </Button>
      ) : (
        <div
          className={clsx(
            "flex px-4 py-2 items-center cursor-pointe transition cursor-pointer",
            "text-gray-700 hover:bg-gray-100 text-sm border-t border-gray-100"
          )}
          onClick={openJoinModal}
        >
          <IconPlus stroke={2.5} size={20} className="mr-2" />
          <span>{t("dashboard.addNewOrganisation")}</span>
        </div>
      )}
      <Modal
        isOpen={openJoin}
        setIsOpen={setOpenJoin}
        containerClassName="md:max-w-3xl px-3"
        closeButton
      >
        <JoinOrganisation close={closeJoinModal} />
      </Modal>
    </>
  );
}

export default observer(JoinCreateOrganisation);
